import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Service Areas', path: '/locations' },
  { label: 'Contact', path: '/#contact' },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-navy/95 backdrop-blur-md shadow-lg shadow-black/20' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3 cursor-pointer">
              <img
                src="https://static.readdy.ai/image/81164d3ba0f00c2a7e247a9f180c9b75/47f8f9906349aca5e74950df5c14b795.webp"
                alt="TrueCare Moving Services Logo"
                className="w-14 h-14 object-contain rounded-full"
              />
              <div>
                <div className="font-heading font-800 text-white text-lg leading-tight tracking-tight">TrueCare</div>
                <div className="text-teal text-[10px] font-body tracking-[0.2em] uppercase leading-tight">Moving Services</div>
              </div>
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`font-body text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    location.pathname === link.path
                      ? 'text-teal'
                      : 'text-white/80 hover:text-teal'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            {/* Right Side */}
            <div className="hidden lg:flex items-center gap-4">
              <a
                href="tel:+16123674481"
                className="flex items-center gap-2 text-white/80 hover:text-teal transition-colors duration-200 font-body text-sm whitespace-nowrap cursor-pointer"
              >
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-phone-line text-teal text-base"></i>
                </div>
                <span className="font-medium">(612) 367-4481</span>
              </a>
              <Link
                to="/#quote"
                className="bg-teal hover:bg-teal-dark text-navy font-heading font-700 text-sm px-5 py-2.5 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer animate-pulse-teal"
              >
                Get Free Quote
              </Link>
            </div>

            {/* Mobile Toggle */}
            <div className="lg:hidden flex items-center gap-3">
              <a
                href="tel:+16123674481"
                className="w-10 h-10 flex items-center justify-center bg-teal/20 rounded-lg cursor-pointer"
              >
                <i className="ri-phone-line text-teal text-lg"></i>
              </a>
              <button
                onClick={() => setMobileOpen(!mobileOpen)}
                className="w-10 h-10 flex items-center justify-center text-white cursor-pointer"
              >
                <i className={`ri-${mobileOpen ? 'close' : 'menu-3'}-line text-2xl`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="lg:hidden bg-navy/98 backdrop-blur-md border-t border-white/10">
            <div className="px-6 py-6 space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="block font-body text-base font-medium text-white/80 hover:text-teal transition-colors py-2 border-b border-white/10 cursor-pointer"
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/#quote"
                className="block bg-teal text-navy font-heading font-700 text-center py-3 rounded-lg mt-4 whitespace-nowrap cursor-pointer"
              >
                Get Free Quote
              </Link>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
